export default __webpack_public_path__ + "static/media/INCIDENTS-Home.7b892a39.png";